import { GET } from './API';

const PATH_ROOT = 'U009';

export type A01Output = {
  auditions: Array<{
    id: string;
    lang: string;
    lp_url: string;
    image: string;
    title: string;
    detail: string;
    end_dtm: string;
    year_round: string;
  }>;
  now_dtm: Date;
  limit: number;
};
export async function A01(lang: string, cancellation?: AbortSignal): Promise<A01Output> {
  return await GET(
    `${PATH_ROOT}/auditions?${new URLSearchParams({
      lang,
      limit: String(100),
    })}`,
    cancellation
  );
}
